import { CustomRoleForUser } from "../common/customRole";

export enum OnboardingStatus {
  incomplete = "incomplete",
  complete = "complete",
}

export type OnboardingStatusResponse = {
  articlesOfAssociation: OnboardingStatus;
  shareholderRegister: OnboardingStatus;
  boardMembers: OnboardingStatus;
  settings: OnboardingStatus;
  payment: OnboardingStatus;
};

export enum OnboardingSaveStatus {
  LOADING = "loading",
  IDLE = "idle",
}

export type OnboardingError = {
  validationError: string;
  context: string;
};

export const shareholderErrors = new Map<string, string>([
  ["invalidSocialSecurityNumber", "onboarding.step.error.invalidSocialSecurityNumber"],
]);

export function isOnboardingComplete(onboardingSteps: OnboardingStatusResponse) {
  return (
    onboardingSteps.articlesOfAssociation === OnboardingStatus.complete &&
    onboardingSteps.boardMembers === OnboardingStatus.complete &&
    onboardingSteps.shareholderRegister === OnboardingStatus.complete &&
    onboardingSteps.settings === OnboardingStatus.complete
  );
}

export function canCompleteOnboardingStep(
  onboardingSteps: OnboardingStatusResponse,
  userRole: CustomRoleForUser | undefined,
) {
  return (
    (onboardingSteps.articlesOfAssociation !== OnboardingStatus.complete &&
      userRole?.allowArticlesEdit) ||
    (onboardingSteps.boardMembers !== OnboardingStatus.complete &&
      userRole?.allowCompanyRolesEdit) ||
    (onboardingSteps.shareholderRegister !== OnboardingStatus.complete &&
      userRole?.allowShareholdersEdit) ||
    (onboardingSteps.settings !== OnboardingStatus.complete && userRole?.allowCompanySettingsEdit)
  );
}
